export const USER = {
  CREATE: 'user.create',
  UPDATE: 'user.update',
  DELETE: 'user.delete',
  GET: 'user.get',
  LIST: 'user.list',
}

export const EVENT = {
  LIST: 'event.list',
  GET: 'event.get',
}

export const METADATA_TREE = {
  SAVE: 'metadata.save',
  GET: 'metadata.get',
  LIST: 'metadata.list',
}

export const INGREDIENT = {
  LIST_BY_KEYWORD: 'ingredient.list.byKeywords',
  LIST: 'ingredient.list',
  GET: 'ingredient.get',
  GET_KEYWORDS: 'ingredient.get.keywords',
  UPDATE_SIMPLE_DETAILS: 'ingredient.update.simpleDetails',
  SAVE_COMPONENT_INGREDIENTS: 'ingredient.update.componentIngredients',
  SAVE_KEYWORDS: 'ingredient.update.keywordsDetails',
  DELETE_KEYWORDS: 'ingredient.update.deleteKeywords',
  SAVE_EXTRA_INGREDIENTS: 'ingredient.update.extraIngredients',
  SAVE_PHRASES: 'ingredient.update.addPhrases',
  DELETE_PHRASES: 'ingredient.update.deletePhrases',
  SAVE_OVERRIDES_INGREDIENTS: 'ingredient.update.overridesIngredients',
  SAVE_ALTERNATIVE_INGREDIENTS: 'ingredient.update.alternativeIngredients',
  UPDATE_IMAGE_DETAILS: 'allergen.update.imageDetails',
  UPDATE_NOTES: 'ingredient.update.notes',
}

export const INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASE = {
  LIST: 'ingredientCommonNegativeSynonym.list',
  SAVE: 'ingredientCommonNegativeSynonym.update',
}

export const INGREDIENT_SPECIAL_CASE = {
  CREATE: 'ingredientSpecial.create',
  UPDATE: 'ingredientSpecial.update',
  DELETE: 'ingredientSpecial.delete',
  LIST: 'ingredientSpecialCase.list',
  GET: 'ingredientSpecialCase.get',
}

export const DISH_TYPE = {
  UPDATE_SIMPLE_DETAILS: 'dishType.update.simpleDetails',
  UPDATE_IGNORED_DETAILS: 'dishType.update.ignoredDetails',
  UPDATE_IMAGE_DETAILS: 'dishType.update.imageDetails',
  SAVE_ADDITIONAL_INGREDIENTS: 'dishType.update.additionalIngredients',
  SAVE_ALTERNATIVE_INGREDIENTS: 'dishType.update.alternativeIngredients',
  UPDATE_NOTES: 'dishType.update.notes',
}

export const COURSE_TYPE = {
  UPDATE_DETAILS: 'courseType.update.details',
  UPDATE_IMAGE_DETAILS: 'allergen.update.imageDetails',
}

export const CUISINE_TYPE = {
  UPDATE_DETAILS: 'cuisineType.update.details',
  UPDATE_IMAGE_DETAILS: 'cuisineType.update.imageDetails',
}

export const AWARD = {
  UPDATE_DETAILS: 'award.update.details',
}

export const LOCATION_TYPE = {
  UPDATE_DETAILS: 'locationType.update.details',
  UPDATE_IMAGE_DETAILS: 'locationType.update.imageDetails',
}

export const ALLERGEN = {
  UPDATE_SIMPLE_DETAILS: 'allergen.update.simpleDetails',
  SAVE_ALLERGENS: 'allergen.update.allergens',
  SAVE_INGREDIENTS: 'allergen.update.ingredients',
  UPDATE_IMAGE_DETAILS: 'allergen.update.imageDetails',
}

export const DIET = {
  UPDATE_SIMPLE_DETAILS: 'diet.update.simpleDetails',
  SAVE_ALLERGENS: 'diet.update.allergens',
  SAVE_INGREDIENTS: 'diet.update.ingredients',
  UPDATE_IMAGE_DETAILS: 'allergen.update.imageDetails',
}

export const DICTIONARY_WORD = {
  CREATE: 'dictionaryWord.create',
  UPDATE: 'dictionaryWord.update',
  DELETE: 'dictionaryWord.delete',
  LIST: 'dictionaryWord.list',
  GET: 'dictionaryWord.get',
}

export const REPORT = {
  LIST: 'report.list',
  GET_FOR_USERS: 'report.getForUsers',
  METADATA_NODES: 'report.metadataNodes',
}

export const CHALLENGE = {
  LIST: 'challenge.list',
  GET: 'challenge.get',
  SAVE: 'challenge.save',
  UPDATE_SIMPLE_DETAILS: 'challenge.update.simpleDetails',
  SAVE_RELATIONS: 'challenge.update.relations',
  UPDATE_IMAGE_DETAILS: 'challenge.update.imageDetails',
}

export const FOOD_MOOD = {
  LIST: 'foodMood.list',
  GET: 'foodMood.get',
  SAVE: 'foodMood.save',
  UPDATE_SIMPLE_DETAILS: 'foodMood.update.simpleDetails',
  SAVE_RELATIONS: 'foodMood.update.relations',
  UPDATE_IMAGE_DETAILS: 'foodMood.update.imageDetails',
}
